import { PlaceListRowSkeleton } from "@ui/Molecules/Place/ListRow/PlaceListRowSkeleton";
import { Bone, SHIMMER_STYLE } from "@ui/Molecules/Skeleton/Bone";
import { FilterRailSkeleton } from "@ui/Organisms/Filter/FilterRailSkeleton";

/** Full-viewport map placeholder; render it inside the same shell as the page. */
export function MapTemplateSkeleton() {
	return (
		<div className="relative h-full">
			<style>{SHIMMER_STYLE}</style>
			<div className="absolute inset-y-0 left-0 right-0 bg-[var(--map-land)] md:left-[296px] md:right-[380px]" />

			<div className="absolute inset-y-0 left-0 hidden w-[296px] overflow-hidden border-r border-[var(--border-default)] bg-[var(--surface-default)] md:block">
				<FilterRailSkeleton />
			</div>

			<div className="absolute inset-y-0 right-0 hidden w-[380px] flex-col border-l border-[var(--border-default)] bg-[var(--surface-default)] md:flex">
				<div className="flex items-baseline justify-between border-b border-[var(--border-subtle)] px-6 py-4">
					<Bone width={110} height={19} />
					<Bone width={80} height={13} />
				</div>
				<div className="px-6">
					{Array.from({ length: 6 }, (_, i) => (
						// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton
						<PlaceListRowSkeleton key={i} />
					))}
				</div>
			</div>

			<div className="absolute inset-x-5 top-[calc(14px+env(safe-area-inset-top))] md:hidden">
				<Bone width="100%" height={44} radius="var(--radius-sm)" />
			</div>
		</div>
	);
}
